import {isTestHost} from './isTestHost';

const PROD_RETURNS_CLIENT_LOGINS = new Set(['65746']);

export const isReturnsEnabled = (login?: string): boolean => {
    return isTestHost || (!!login && PROD_RETURNS_CLIENT_LOGINS.has(login));
};
